import Affix from './Affix';

export default Affix;
